import PaymentsPageBody from "../components/paymentsPage/PaymentsPageBody";

const PaymentsPage = () => {
    return(<PaymentsPageBody/>)
}

export default PaymentsPage;